import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

import type { TypeTab } from 'src/types/Tabs';

import { showNewLayout } from './new_layout';

/** @deprecated Legacy dashboard tab — new layout skips activity log tab. */
export const dashboardActivityLogTab: TypeTab = {
	id: -10,
	key: 'event_log',
	text: 'tab_activity_log',
	defaultText: 'activity log',
	route: '/event_log',
};

const dashboardCameraMonitoringTab: TypeTab = {
	id: -11,
	key: 'camera_monitoring',
	text: 'tab_camera_monitoring',
	defaultText: 'Camera Monitoring',
	route: '/camera_monitoring',
	icon: 'fas fa-video',
};

/** Prepends camera monitoring (and activity log on legacy layout). */
export const getCameraDashboardTabs = <T>(dashboardTabsSort: T[]) => {
	const cameraMonitoringTab: TypeTab = {
		...dashboardCameraMonitoringTab,
		text: get(format)(dashboardCameraMonitoringTab.text, {
			default: dashboardCameraMonitoringTab.defaultText,
		}),
	};

	if (get(showNewLayout)) {
		return [cameraMonitoringTab, ...dashboardTabsSort];
	}
	return [dashboardActivityLogTab, cameraMonitoringTab, ...dashboardTabsSort];
};

/** Prepends activity log tab on legacy layout only. */
export const prependLegacyActivityLogTab = <T>(dashboardTabsSort: T[]) => {
	if (get(showNewLayout)) {
		return [...dashboardTabsSort];
	}
	return [dashboardActivityLogTab, ...dashboardTabsSort];
};
